import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import styles from './Sponsor.module.styl';

const Sponsor = ({ layout, className }) => {
  const data = useStaticQuery(graphql`
      query SponsorLogoQuery {
          northeasternLogo: file(name: {eq: "northeastern"}) {
              id
              name
              childImageSharp {
                  fluid(maxWidth: 200) {
                      src
                      srcSet
                  }
              }
          }
      }
  `);

  return (
    <aside className={className}>
      <div
        className={classNames(
          styles.sponsor,
          styles[layout],
        )}
      >
        <span className={classNames('bentoncond-n4', styles.label)}>
          Supported By
        </span>
        <a
          href="https://pages.northeastern.edu/DMSB-OPP-EVG-DOM-COMP-BOS-BUS-DEF-OFA-2021-04-02-Boston-Globe-Future-of-Work_Future-of-Work-LP.html?utm_medium=offline-advertising&utm_source=magazine-bostonglobe&utm_campaign=dmsb-opp-evg-dom-comp-bos-bus-def-ofa-2021_04_02-bostonglobe_futureofwork"
          target="_blank"
          rel="noreferrer noopener"
          className={styles.link}
        >
          <img
            src={data.northeasternLogo.childImageSharp.fluid.src}
            srcSet={data.northeasternLogo.childImageSharp.fluid.srcSet}
            sizes="200w"
            alt="Northeastern University D'Amore-McKim School of Business"
            width="200"
          />
        </a>
      </div>
    </aside>
  );
};

Sponsor.propTypes = {
  layout: PropTypes.oneOf(['side', 'stacked']).isRequired,
  className: PropTypes.string,
};

Sponsor.defaultProps = {
  className: '',
};

export default Sponsor;
